
import {
  IsotopeDto,
  CreateIsotopeDto,
  UpdateIsotopeDto,
  ActivityLevel,
} from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { PaginatedQueryBase } from './api'

export type IsotopesFilters = PaginatedQueryBase & {
  search?: string
  includeInactive?: boolean
  activityLevel?: ActivityLevel
}

class IsotopeService extends BaseCrudService<
  IsotopeDto,
  CreateIsotopeDto,
  UpdateIsotopeDto,
  IsotopesFilters
> {
  constructor() {
    super('isotope', process.env.REACT_APP_RADIOPHARMACY_API_URL)
  }
}

export const isotopeService = new IsotopeService()
